/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockSetAssembleDtEditor extends Serenity.Extensions.GridEditorBase<IcStockSetAssembleDtRow> {
        protected getColumnsKey() { return "Inventory.IcStockSetAssembleDt"; }
        protected getDialogType() { return IcStockSetAssembleDtDialog; }
        protected getLocalTextPrefix() { return IcStockSetAssembleDtRow.localTextPrefix; }

        public qnNo: number;    
        public myPassValue: string;
        private _qty: number;
        private _setitemcode : string;
        constructor(container: JQuery) {
            super(container);

            
        
        }
      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            //let self = this;
            //self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            
            
            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }

        แ
        
   
    

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            //--set new set of grid columns---
            //--get content width
            let ele = document.getElementsByClassName("grid-container");
            var bordermg = 60;
            var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            var totalcolw = 0;

            let propItems = this.getPropertyItems();
            let items = this.getColumns();
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                totalcolw += pItem.width;

            });
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                pItem.resizable = true;
                pItem.width = (eleWidth / totalcolw) * pItem.width;


            });

            let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            grid.setColumns(c);
            grid.resizeCanvas();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    //new Slick.Aggregators.Sum('PurUnitRatio'),
                    //new Slick.Aggregators.Sum('PurUnitPrice'),
                    //new Slick.Aggregators.Sum('UnitCost'),
                    new Slick.Aggregators.Sum('CostValue')
                ]
            });
            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

        public get SetItemCode(): string { return this._setitemcode; }
        public get QtySetItem(): number { return this._qty; }

        set SetItemCode(value: string){
            if(this._setitemcode != value){
                
                this.clearDataGrid();
                var row =  Product.PsSetItemDtRow.getLookup().items.filter(x => x.SetItemCode == value)
                var i = 0;
                for (var po of row){
                    i++;
                    var item = <IcStockSetAssembleDtRow>{
                        LineItemNo: i,
                        PluCode: po.PluCode,
                        PluDesc: po.PluDesc,
                        SellUnitRatio : (Product.CsPluRow.getLookup().itemById[po.PluCode].SellUnitRatio),
                        SetItemQty: po.Qty,
                        SetQty: 1,
                        Qty: po.Qty,
                        SkuCode: (Product.CsPluRow.getLookup().itemById[po.PluCode].SkuCode),
                        SkuQty :(Product.CsPluRow.getLookup().itemById[po.PluCode].SellUnitRatio)*po.Qty,
                        Remark: ''
                        ,
                        ExpDate: ''
                        
                    };
                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()]= id;
                    this.view.addItem(item);
                }
                this.refresh();
            }

             
        }

        set QtySetItem(value: number){
           if(this._qty != value){
                console.log("QtySetItem: " + value);        
                var row =  this.view.getRows();
                this.clearDataGrid();
                var i = 0;
                for (var po of row){
                    i++;
                    var item = <IcStockSetAssembleDtRow>{
                        LineItemNo: i,
                        PluCode: po.PluCode,
                        PluDesc: po.PluDesc,
                        SellUnitRatio : po.SellUnitRatio,
                        SetItemQty: po.SetItemQty,                        
                        SetQty: value,
                        Qty: po.SetItemQty * value,
                        Remark: po.Remark 
                        ,
                        ExpDate: po.ExpDate,
                        SkuCode: po.SkuCode,
                        SkuQty :  (po.SetItemQty * value)*po.SellUnitRatio
                        
                    };
                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()]= id;
                    this.view.addItem(item);
                }

                //this.clearDataGrid();
                this.refresh();
            }
        }
    
        public clearDataGrid(){
            this.view.setItems([],true);
        }

        // validateEntity(row, id) {
        //     row.SysDocNo = Q.toId(row.SysDocNo);
        //     var sameProduct = Q.tryFirst(this.view.getItems(), x => x.SysDocNo === row.SysDocNo);
        //     if (sameProduct && this.id(sameProduct) !== id) {
        //         Q.warning('This product is already in order details!');
        //         return false;
        //     }
    
        //     // if(row.Qty <= 0){
        //     //     alertDialog('Qty not null!');
        //     //     return false;
        //     // }
    
        //     id ??= row[this.getIdProperty()];
    
        //     ProductRow.getLookupAsync().then(async lookup => {
        //         var item = this.view?.getItemById?.(id);
        //         if (item) {
        //             item.ProdCode = lookup.itemById[row.ProdId].ProdCode;
        //             item.Description = lookup.itemById[row.ProdId].ProdName;
        //             item.UomId = lookup.itemById[row.ProdId].PurUom;
        //             item.UomCode = (await ProductUomRow.getLookupAsync()).itemById[item.UomId].UomName;
        //             console.log("Uom: " + item.UomId);
        //             this.view.updateItem(id, item);
        //         }
        //     });
    
        //     row.LineNo = id.toString().substr(-1);
        //     row.NetPrice = (row.Qty || 0) * (row.UnitPrice || 0) - (row.disAmt || 0);
        //     return true;
        // }

    }
}

